// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_PRODUCT_title_MODIFIED_SUCCESSFULLY = "Inzer\u00e1t \"%(title)s\" bol \u00faspe\u0161ne zmenen\u00fd.";
